import { AiOutlineCaretLeft, AiOutlineCaretRight } from "react-icons/ai"; 

import { BsCaretLeft } from "react-icons/bs"; 

import { BsChevronCompactLeft, BsChevronCompactRight } from "react-icons/bs"; 
import { AiOutlineVerticalLeft, AiOutlineVerticalRight } from "react-icons/ai"; 
import { AiOutlineDoubleLeft, AiOutlineDoubleRight } from "react-icons/ai"; 
import { IoCheckmarkSharp,IoCheckmarkDoneSharp } from "react-icons/io5"; 
import { ImUsers } from "react-icons/im"; 
import { VscCheck ,VscCheckAll} from "react-icons"
import {AiFillLike, AiFillDislike } from "react-icons/ai"; 
// import {  } from "react-icons/ai"; 
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
const MessageBoardSearch = ({ updateUserPoints, showConfirmationDialog, user }) => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchLoading, setSearchLoading] = useState(false);
  const [expandedPosts, setExpandedPosts] = useState(new Set());
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalPosts: 0,
    hasNextPage: false,
    hasPrevPage: false
  });
  
  // Search filters
  const [searchFilters, setSearchFilters] = useState({
    search: '',
    dateFrom: '',
    dateTo: '',
    userId: '',
    excludeSameSex: true
  });
  
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 10;
  const [currentUser, setCurrentUser] = useState(null);
  const [hasConfirmedView, setHasConfirmedView] = useState(false);
  const [hasDeductedPoints, setHasDeductedPoints] = useState(false);

  // First useEffect - handle point deduction when user confirms viewing
  useEffect(() => {
    const handlePointDeduction = async () => {
      if (hasConfirmedView && !hasDeductedPoints) {
        try {
          const token = localStorage.getItem('token');
          const pointCheckResponse = await axios.get(`${API_URL}/api/point-costs`);
          const messageBoardViewCost = pointCheckResponse.data.find(cost => cost.actionName === 'message_board_view');
          
          if (messageBoardViewCost && messageBoardViewCost.pointCost > 0) {
            const deductResponse = await axios.post(`${API_URL}/api/users/deduct-points`, {
              actionName: 'message_board_view'
            }, {
              headers: { Authorization: `Bearer ${token}` }
            });
            
            if (deductResponse.data.success) {
              updateUserPoints(deductResponse.data.remainingPoints);
              setHasDeductedPoints(true);
            } else {
              alert(`ポイントが不足しています。\n必要ポイント: ${deductResponse.data.required}pt\n所持ポイント: ${deductResponse.data.available}pt`);
              setHasConfirmedView(false);
              return;
            }
          } else {
            setHasDeductedPoints(true);
          }
        } catch (error) {
          console.error('Error deducting points:', error);
          alert('あなたのポイント数が足りません。');
          setHasConfirmedView(false);
        }
      }
    };
    
    handlePointDeduction();
  }, [hasConfirmedView, hasDeductedPoints]);

  // Second useEffect - fetch data after point deduction
  useEffect(() => {
    if (hasDeductedPoints) {
      fetchPosts();
      fetchCurrentUser();
    }
  }, [currentPage, hasDeductedPoints]);

  // Third useEffect - show confirmation dialog when component mounts
  useEffect(() => {
    const showConfirmation = async () => {
      if (!hasConfirmedView && !hasDeductedPoints) {
        try {
          const pointCheckResponse = await axios.get(`${API_URL}/api/point-costs`);
          const messageBoardViewCost = pointCheckResponse.data.find(cost => cost.actionName === 'message_board_view');
          
          if (messageBoardViewCost && messageBoardViewCost.pointCost > 0) {
            // Skip confirmation; proceed to deduction phase
            setHasConfirmedView(true);
          } else {
            setHasConfirmedView(true);
            setHasDeductedPoints(true);
          }
        } catch (error) {
          console.error('Error checking point costs:', error);
        }
      }
    };
    
    showConfirmation();
    
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const fetchCurrentUser = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/api/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCurrentUser(response.data);
    } catch (error) {
      console.error('Error fetching current user:', error);
    }
  };

  const fetchPosts = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const params = {
        page: currentPage,
        limit: postsPerPage,
        ...searchFilters
      };
      
      console.log('Search params:', params); // Debug log
      
      const response = await axios.get(`${API_URL}/api/board`, {
        headers: { Authorization: `Bearer ${token}` },
        params
      });
      
      console.log('Search response:', response.data); // Debug log
      
      setPosts(response.data.posts);
      setPagination(response.data.pagination);
    } catch (error) {
      console.error('Error fetching posts:', error);
      if (error.response?.status === 400) {
        alert('検索条件に問題があります。もう一度お試しください。');
      } else {
        alert('投稿の取得に失敗しました。もう一度お試しください。');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const handleSearch = async () => {
    setSearchLoading(true);
    setCurrentPage(1); // Reset to first page when searching
    try {
      await fetchPosts(); // Trigger a new search
    } finally {
      setSearchLoading(false);
    }
  };

  const clearFilters = async () => {
    setSearchLoading(true);
    setSearchFilters({
      search: '',
      dateFrom: '',
      dateTo: '',
      userId: '',
      excludeSameSex: true
    });
    setCurrentPage(1);
    try {
      await fetchPosts(); // Trigger a new search after clearing filters
    } finally {
      setSearchLoading(false);
    }
  };

  const togglePostExpansion = (postId) => {
    setExpandedPosts(prev => {
      const newSet = new Set(prev);
      if (newSet.has(postId)) {
        newSet.delete(postId);
      } else {
        newSet.add(postId);
      }
      return newSet;
    });
  };

  const incrementReaderCount = async (postId) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.put(`${API_URL}/api/board/${postId}/read`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      // Update the reader count and readBy array in the local state
      setPosts(prev => prev.map(post => 
        post._id === postId 
          ? { 
              ...post, 
              readerCount: response.data.readerCount,
              readBy: response.data.alreadyRead ? post.readBy : [...(post.readBy || []), currentUser]
            }
          : post
      ));
    } catch (error) {
      console.error('Error incrementing reader count:', error);
    }
  };

  const handlePostClick = (postId) => {
    // Remove automatic reader count increment
    // incrementReaderCount(postId);
  };

  const handleReadButton = async (postId, e) => {
    e.stopPropagation(); // Prevent triggering post click
    await incrementReaderCount(postId);
  };

  const handleLike = async (postId, e) => {
    e.stopPropagation();
    try {
      const token = localStorage.getItem('token');
      const response = await axios.put(`${API_URL}/api/board/${postId}/like`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      // Update the post in local state
      setPosts(prev => prev.map(post => 
        post._id === postId 
          ? { 
              ...post, 
              likes: response.data.likes,
              dislikes: response.data.dislikes
            }
          : post
      ));
    } catch (error) {
      console.error('Error liking post:', error);
      alert('いいねの処理に失敗しました');
    }
  };

  const handleDislike = async (postId, e) => {
    e.stopPropagation();
    try {
      const token = localStorage.getItem('token');
      const response = await axios.put(`${API_URL}/api/board/${postId}/dislike`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      // Update the post in local state
      setPosts(prev => prev.map(post => 
        post._id === postId 
          ? { 
              ...post, 
              likes: response.data.likes,
              dislikes: response.data.dislikes
            }
          : post
      ));
    } catch (error) {
      console.error('Error disliking post:', error);
      alert('よくないねの処理に失敗しました');
    }
  };

  const isLikedByCurrentUser = (post) => {
    return currentUser && post.likes && post.likes.some(like => like._id === currentUser._id);
  };

  const isDislikedByCurrentUser = (post) => {
    return currentUser && post.dislikes && post.dislikes.some(dislike => dislike._id === currentUser._id);
  };

  const hasReadByCurrentUser = (post) => {
    return currentUser && post.readBy && post.readBy.some(reader => reader._id === currentUser._id);
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <p>読み込み中...</p>
      </div>
    );
  }

  return (
    <div style={{ padding: isMobile ? '10px' : '0px' }}>
      <h2 style={{ 
        color: '#333', 
        marginBottom: '20px',
        fontSize: isMobile ? '20px' : '24px'
      }}>掲示板検索</h2>
      
      {/* Search Filters */}
      <div style={{ 
        backgroundColor: 'white', 
        padding: isMobile ? '15px' : '20px', 
        borderRadius: '8px',
        marginBottom: '20px'
      }}>
        <h3 style={{ 
          marginBottom: '15px',
          fontSize: isMobile ? '16px' : '18px'
        }}>検索条件</h3>
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(50px, 1fr))', 
          gap: isMobile ? '15px' : '5px', 
          marginBottom: '15px' 
        }}>
          <div>
            <label style={{ display: 'block', marginBottom: '5px' }}>キーワード検索</label>
            <input
              type="text"
              value={searchFilters.search}
              onChange={(e) => setSearchFilters(prev => ({ ...prev, search: e.target.value }))}
              onKeyPress={handleKeyPress}
              placeholder="タイトル・内容で検索..."
              style={{ 
                width: isMobile ? '100%' : '85%', 
                padding: isMobile ? '12px' : '8px', 
                borderRadius: '5px', 
                border: '1px solid #ddd',
                fontSize: isMobile ? '16px' : '14px'
              }}
            />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '5px' }}>投稿者</label>
            <input
              type="text"
              value={searchFilters.userId}
              onChange={(e) => setSearchFilters(prev => ({ ...prev, userId: e.target.value }))}
              onKeyPress={handleKeyPress}
              placeholder="ユーザーID・名前で検索..."
              style={{ 
                width: isMobile ? '100%' : '85%', 
                padding: isMobile ? '12px' : '8px', 
                borderRadius: '5px', 
                border: '1px solid #ddd',
                fontSize: isMobile ? '16px' : '14px'
              }}
            />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '5px' }}>開始日</label>
            <input
              type="date"
              value={searchFilters.dateFrom}
              onChange={(e) => setSearchFilters(prev => ({ ...prev, dateFrom: e.target.value }))}
              onKeyPress={handleKeyPress}
              style={{ 
                width: isMobile ? '100%' : '85%', 
                padding: isMobile ? '12px' : '8px', 
                borderRadius: '5px', 
                border: '1px solid #ddd',
                fontSize: isMobile ? '16px' : '14px'
              }}
            />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '5px' }}>終了日</label>
            <input
              type="date"
              value={searchFilters.dateTo}
              onChange={(e) => setSearchFilters(prev => ({ ...prev, dateTo: e.target.value }))}
              onKeyPress={handleKeyPress}
              style={{ 
                width: isMobile ? '100%' : '85%', 
                padding: isMobile ? '12px' : '8px', 
                borderRadius: '5px', 
                border: '1px solid #ddd',
                fontSize: isMobile ? '16px' : '14px'
              }}
            />
          </div>
          {/* <div style={{ display: 'flex', alignItems: 'flex-end' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <input
                type="checkbox"
                checked={searchFilters.excludeSameSex}
                onChange={(e) => setSearchFilters(prev => ({ ...prev, excludeSameSex: e.target.checked }))}
              />
              同性を除外する
            </label>
          </div> */}
        </div>
        <div style={{ 
          display: 'flex', 
          gap: '10px',
          flexDirection: isMobile ? 'column' : 'row'
        }}>
          <button
            onClick={handleSearch}
            style={{
              backgroundColor: '#ff6b35',
              color: 'white',
              border: 'none',
              padding: isMobile ? '15px 20px' : '10px 20px',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: isMobile ? '16px' : '14px',
              width: isMobile ? '100%' : 'auto'
            }}
            disabled={searchLoading}
          >
            {searchLoading ? '検索中...' : '検索'}
          </button>
          <button
            onClick={clearFilters}
            style={{
              backgroundColor: '#666',
              color: 'white',
              border: 'none',
              padding: isMobile ? '15px 20px' : '10px 20px',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: isMobile ? '16px' : '14px',
              width: isMobile ? '100%' : 'auto'
            }}
            disabled={searchLoading}
          >
            {searchLoading ? 'クリア中...' : 'クリア'}
          </button>
        </div>
      </div>

      {/* Results */}
      <div style={{ 
        backgroundColor: 'white', 
        padding: '10px', 
        borderRadius: '8px'
        
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h3>検索結果 ({pagination.totalPosts}件)</h3>
          {pagination.totalPages > 1 && (
              <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                gap: '10px', 
                marginTop: '30px' 
              }}>
                <button
                  onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                  disabled={!pagination.hasPrevPage}
                  style={{
                    // backgroundColor: pagination.hasPrevPage ? '#007bff' : '#ccc',
                    color: 'black',
                    border: 'none',
                    fontSize: '16px',
                    padding: '8px 10px',
                    borderRadius: '5px',
                    cursor: pagination.hasPrevPage ? 'pointer' : 'not-allowed'
                  }}
                >
                  <AiOutlineCaretLeft />
                </button>
                
                <span style={{ fontSize: '14px' , paddingBottom : '5px'}}>
                  {pagination.currentPage} / {pagination.totalPages}
                </span>
                
                <button
                  onClick={() => setCurrentPage(prev => Math.min(pagination.totalPages, prev + 1))}
                  disabled={!pagination.hasNextPage}
                  style={{
                    // backgroundColor: pagination.hasNextPage ? '#007bff' : '#ccc',
                    color: 'black',
                    fontSize: '16px',
                    border: 'none',
                    padding: '8px 10px',
                    borderRadius: '5px',
                    cursor: pagination.hasNextPage ? 'pointer' : 'not-allowed'
                  }}
                >
                  <AiOutlineCaretRight />
                </button>
              </div>
            )}
          {/* <div style={{ fontSize: '14px', color: '#666' }}>
            ページ {pagination.currentPage} / {pagination.totalPages}
          </div> */}
        </div>
        
        {/* Show active search filters */}
        {(searchFilters.search || searchFilters.userId || searchFilters.dateFrom || searchFilters.dateTo || searchFilters.excludeSameSex) && (
          <div style={{ 
            backgroundColor: '#f8f9fa', 
            padding: '10px 5px', 
            borderRadius: '5px', 
            marginBottom: '20px',
            border: '1px solid #dee2e6'
          }}>
            <div style={{ fontSize: '14px', color: '#495057', marginBottom: '5px' }}>
              <strong>現在の検索条件:</strong>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
              {searchFilters.search && (
                <span style={{ 
                  backgroundColor: '#007bff', 
                  color: 'white', 
                  padding: '4px 8px', 
                  borderRadius: '12px', 
                  fontSize: '12px' 
                }}>
                  キーワード: {searchFilters.search}
                </span>
              )}
              {searchFilters.userId && (
                <span style={{ 
                  backgroundColor: '#28a745', 
                  color: 'white', 
                  padding: '4px 8px', 
                  borderRadius: '12px', 
                  fontSize: '12px' 
                }}>
                  投稿者: {searchFilters.userId}
                </span>
              )}
              {searchFilters.dateFrom && (
                <span style={{ 
                  backgroundColor: '#ffc107', 
                  color: '#212529', 
                  padding: '4px 8px', 
                  borderRadius: '12px', 
                  fontSize: '12px' 
                }}>
                  開始日: {searchFilters.dateFrom}
                </span>
              )}
              {searchFilters.dateTo && (
                <span style={{ 
                  backgroundColor: '#ffc107', 
                  color: '#212529', 
                  padding: '4px 8px', 
                  borderRadius: '12px', 
                  fontSize: '12px' 
                }}>
                  終了日: {searchFilters.dateTo}
                </span>
              )}
              {searchFilters.excludeSameSex && (
                <span style={{ 
                  backgroundColor: '#17a2b8', 
                  color: 'white', 
                  padding: '4px 8px', 
                  borderRadius: '12px', 
                  fontSize: '12px' 
                }}>
                  同性を除外
                </span>
              )}
            </div>
          </div>
        )}
        

        {posts.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '10px' }}>
            <p style={{ fontSize: '18px', color: '#666' }}>投稿が見つかりませんでした</p>
          </div>
        ) : (
          <>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {posts.map((post) => (
                // console.log(post),
                <div 
                  key={post._id} 
                  style={{ 
                    
                    border: '1px solid #ddd', 
                    borderRadius: '8px', 
                    padding: '20px',
                    position: 'relative',
                    // cursor: 'pointer',
                    transition: 'box-shadow 0.2s'
                  }}
                  onMouseEnter={(e) => e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)'}
                  onMouseLeave={(e) => e.target.style.boxShadow = 'none'}
                  onClick={() => handlePostClick(post._id)}
                >
                  {/* ... existing post layout ... */}
                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'flex-start', 
                    gap: isMobile ? '10px' : '15px', 
                    marginBottom: '15px',
                    flexDirection: isMobile ? 'column' : 'row'
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: isMobile ? '10px' : '15px' }}>
                      {post.userID?.photoLink ? (
                        <img 
                          src={post.userID.photoLink.photodatas || post.userID.photoLink} 
                          alt="Profile" 
                          style={{ 
                            width: isMobile ? '40px' : '50px', 
                            height: isMobile ? '40px' : '50px', 
                            borderRadius: '50%',
                            objectFit: 'cover'
                          }} 
                        />
                      ) : (
                        <div style={{ 
                          width: isMobile ? '40px' : '50px', 
                          height: isMobile ? '40px' : '50px', 
                          borderRadius: '50%', 
                          backgroundColor: '#ddd',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: isMobile ? '10px' : '12px'
                        }}>
                          なし
                        </div>
                      )}
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <h4 style={{ 
                          margin: '0 0 5px 0',
                          wordBreak: 'break-word',
                          overflowWrap: 'break-word',
                          whiteSpace: 'normal',
                          lineHeight: '1.4',
                          fontSize: isMobile ? '14px' : '16px',
                          fontWeight: '600',
                          color: '#333'
                        }}>
                          {post.title}
                        </h4>
                        <p style={{ 
                          margin: '0', 
                          color: '#666', 
                          fontSize: isMobile ? '12px' : '14px' 
                        }}>
                          {post.userID?.name || 'Unknown'} ({post.userID?.userID || 'N/A'}) • {new Date(post.created_at).toLocaleString('ja-JP')}
                        </p>
                      </div>
                    </div>
                  </div>
                  
                  {/* ... rest unchanged ... */}

                  {/* Reader count in bottom right */}
                  <div style={{
                    position: 'absolute',
                    bottom: '5px',
                    right: '20px',
                    color: '#666',
                    fontSize: '14px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px'
                  }}>
                    <button
                      onClick={(e) => handleReadButton(post._id, e)}
                      style={{
                        backgroundColor: 'transparent',
                        color: hasReadByCurrentUser(post) ? '#28a745' : '#6c757d',
                        border: 'none',
                        padding: '5px 10px',
                        borderRadius: '3px',
                        cursor: 'pointer',
                        fontSize: '16px',
                        fontWeight: 'bold'
                      }}
                    >
                      {hasReadByCurrentUser(post) ? <IoCheckmarkDoneSharp style={{fontSize:'18px'}} /> : <IoCheckmarkSharp style={{fontSize:'18px'}} />}
                    </button>
                    <span><ImUsers style={{fontSize:'18px', paddingTop:'10px'}} /> {post.readerCount || 0} 読者</span>
                  </div>

                  {/* Like/Dislike buttons in bottom left */}
                  <div style={{
                    position: 'absolute',
                    bottom: '15px',
                    right: '140px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px'
                  }}>
                    <button
                      onClick={(e) => handleLike(post._id, e)}
                      style={{
                        backgroundColor: isLikedByCurrentUser(post) ? '#28a745' : '#6c757d',
                        color: 'white',
                        border: 'none',
                        padding: '5px 10px',
                        borderRadius: '3px',
                        cursor: 'pointer',
                        fontSize: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '5px'
                      }}
                    >
                      <AiFillLike style={{color:"orange", fontSize:"18px"}}/> {post.likes ? post.likes.length : 0}
                    </button>
                    <button
                      onClick={(e) => handleDislike(post._id, e)}
                      style={{
                        backgroundColor: isDislikedByCurrentUser(post) ? '#dc3545' : '#6c757d',
                        color: 'white',
                        border: 'none',
                        
                        padding: '5px 10px',
                        borderRadius: '3px',
                        cursor: 'pointer',
                        fontSize: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '5px'
                      }}
                    >
                      <AiFillDislike style={{color:"orange", fontSize:"18px"}}/> {post.dislikes ? post.dislikes.length : 0}
                    </button>
                  </div>
                </div>
              ))}
            </div>
            
            {/* Pagination */}
            {pagination.totalPages > 1 && (
              <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                gap: '10px', 
                marginTop: '30px' 
              }}>
                <button
                  onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                  disabled={!pagination.hasPrevPage}
                  style={{
                    // backgroundColor: pagination.hasPrevPage ? '#007bff' : '#ccc',
                    color: 'black',
                    border: 'none',
                    fontSize: '16px',
                    padding: '8px 10px',
                    borderRadius: '5px',
                    cursor: pagination.hasPrevPage ? 'pointer' : 'not-allowed'
                  }}
                >
                  <AiOutlineCaretLeft />
                </button>
                
                <span style={{ fontSize: '14px' , paddingBottom : '5px'}}>
                  {pagination.currentPage} / {pagination.totalPages}
                </span>
                
                <button
                  onClick={() => setCurrentPage(prev => Math.min(pagination.totalPages, prev + 1))}
                  disabled={!pagination.hasNextPage}
                  style={{
                    // backgroundColor: pagination.hasNextPage ? '#007bff' : '#ccc',
                    color: 'black',
                    fontSize: '16px',
                    border: 'none',
                    padding: '8px 10px',
                    borderRadius: '5px',
                    cursor: pagination.hasNextPage ? 'pointer' : 'not-allowed'
                  }}
                >
                  <AiOutlineCaretRight />
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default MessageBoardSearch; 